import React, { useContext } from 'react';
import styled, { css } from 'styled-components';
import { ReactComponent as BaseDeleteIcon } from '@ubeya/shared-web/assets/compliance-delete.svg';
import { ReactComponent as BaseDownloadIcon } from '@ubeya/shared-web/assets/compliance-download.svg';
import { ReactComponent as BasePreviewIcon } from '@ubeya/shared-web/assets/compliance-preview.svg';

import { Flex, PromptClick } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const Wrapper = styled(Flex)`
  margin: 20px 0;
  width: ${({ $showPreview }) => ($showPreview ? 120 : 80)}px;
  position: absolute;
  bottom: 0;
  left: 0;
  margin: 8px;
  background-color: ${({ theme }) => theme.colors.white};
  height: 46px;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
  justify-content: space-between;
  align-items: center;
  overflow-x: hidden;
`;

const icon = css`
  &:hover {
    cursor: pointer;
  }
`;

const DeleteIcon = styled(BaseDeleteIcon)`
  ${icon}
`;

const DownloadIcon = styled(BaseDownloadIcon)`
  ${icon}
`;

const PreviewIcon = styled(BasePreviewIcon)`
  ${icon}
`;

const AttachmentActionsRenderer = ({ onDelete, onPreview, onDownload, showPreview }) => {
  const { t } = useContext(ConfigContext);

  return (
    <Wrapper $showPreview={showPreview}>
      {showPreview && <PreviewIcon onClick={onPreview} />}
      <DownloadIcon onClick={onDownload} />
      <PromptClick body={t('areYouSureDeleteDocument')} confirmText="delete" onClick={onDelete}>
        <DeleteIcon onClick={onDelete} />
      </PromptClick>
    </Wrapper>
  );
};

export default AttachmentActionsRenderer;
